module.exports = __webpack_public_path__ + "c07e1ed7dc9cb6c6bf11687ca98c35fe.pdf";